import { getTimezoneOffset } from "date-fns-tz";
import { maxBy } from "lodash-es";
import { rawIntervalToSeconds } from "../../../../utils/interval";
import type { MomentFormSchedule } from "../../../moment/types/moment-form-moment";

export function isScheduleAfter(
  schedule: MomentFormSchedule,
  timezone: string | null,
  recipientTimezones: string[],
  targetDate: Date,
): boolean {
  const { send_at, interval_json, event_repeat, event } = schedule;

  if (event_repeat) return true;
  if (!(send_at as string)) return true;
  if (!event) return true;

  if (!event.calendar) return true; // People events always _might_ send

  const date = event.date as string;

  // Build UTC date
  const event_date = new Date(`${date}T${send_at}Z`);
  event_date.setSeconds(rawIntervalToSeconds(interval_json));

  // Convert to moment timezone or latest possible person timezone
  const defaultTimezone =
    timezone ?? maxBy(recipientTimezones, (x) => getTimezoneOffset(x, event_date));

  event_date.setSeconds(-getTimezoneOffset(defaultTimezone ?? "Etc/GMT-12", event_date) / 1000);

  return event_date > targetDate;
}

export function isFuture(
  schedule: MomentFormSchedule,
  timezone: string | null,
  recipientTimezones: string[],
): boolean {
  return isScheduleAfter(schedule, timezone, recipientTimezones, new Date());
}
